import axios from 'axios';

export default function (context, val) {
    context.commit('loading', true);
    let data =context.getters['form/data'];
    let rData ='';
    for(let k in data){
        switch (k){
            case 'StartDate':
            case 'EndDate':
            case 'IssueDate':
                rData+='Certificate['+k+'][Serialized]='+data[k].Serialized+'&';
                break;
            default:
                rData+='Certificate['+k+']='+data[k]+'&'
        }
    }
    axios({
        method: 'post',
        url: '/tourclient/api/giftCertificate',
        data: rData,
    }).then(({data}) => {
        context.commit('loading', false);
        window.app.$router.push('/finances/certificates');
    }).catch(e => {
        context.commit('loading', false);
        context.dispatch('error', e, {root: true});
    })
}